<template>
	<div>
		<div class="catalog">
			<ul class="catalog-chapters">
				<!--<li class="catalog-chapter">
					<div class="catalog-chapter-title">第01章·文学阅读的发展</div>
					<ul class="catalog-items">
						<li class="catalog-item">
							<div class="catalog-item-title">第01节·文学阅读在国际上的兴起</div>
							<div class="catalog-item-time"><img src="./play.png">25:33</div>
						</li>
						<li class="catalog-item">
							<div class="catalog-item-title">第01节·文学阅读在中国的发展</div>
							<div class="catalog-item-time"><img src="./play.png">25:33</div>
						</li>
					</ul>
				</li>-->
				<li class="catalog-chapter" v-for="(item,index) in lessons">
					<div class="catalog-chapter-title o1">第 {{index+1}} 章 · {{item.title}}</div>
					<ul class="catalog-items">
						<!--<li class="catalog-item">
							<div class="catalog-item-title">第01节·人文的概述</div>
							<div class="catalog-item-time"><img src="./play.png">25:33</div>
						</li>-->
						<li class="catalog-item" v-for="(value,num) in item.children" @click="selectChapter(value)">
							<div class="catalog-item-title o1">第 {{num+1}} 节 · {{value.title}}</div>
							<div class="catalog-item-time">{{countTime(value.video_time)}}</div>
						</li>
					</ul>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				lessons:[]
			}
		},
		created(){
      //获取导航参数
      function geturl_j2(name){
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
      }
      var v_key = geturl_j2('v_key');
      if (!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        window.location.href = "/mooc_free_login/video.html?section_id="+ this.$route.params.id +"&course_id="+ this.$route.params.courseId +"&v_key="+ v_key;
      }
			//获取课程
			this.$api.get("",{
				api:"/v1/course/getCata",
				course_id:this.$route.params.courseId
			},res => {
				this.lessons=res.data;
				this.$nextTick(this.addTitleActive);
			})
		},
		mounted(){

		},
		methods:{
			numConversion(num){
				switch(num){
					case 1:return "一";break;
					case 2:return "二";break;
					case 3:return "三";break;
					case 4:return "四";break;
					case 5:return "五";break;
					case 6:return "六";break;
					case 7:return "七";break;
					case 8:return "八";break;
					case 9:return "九";break;
				}
			},
			countTime(time){
				var hour,
					minute,
					second;
				hour=parseInt(time/3600);
				if(hour<10) hour="0"+hour;
				minute=parseInt(time/60%60);
				if(minute<10) minute="0"+minute;
				second=parseInt(time%60);
				if(second<10) second="0"+second;
				return hour+":"+minute+":"+second;
			},
			selectChapter(item){
				this.$router.replace('/lesson-chapter/'+this.$route.params.courseId+'/'+item.id);
			},
			addTitleActive(id){
				var lessons=this.lessons;
				var index=0;
				var id=id?id:this.$route.params.id;
				id=parseInt(id);
				findIndex:
				for(var i=0;i<lessons.length;i++){
					for(var j=0;j<lessons[i].children.length;j++){
						if(lessons[i].children[j].id===id){
							var domList=document.querySelectorAll(".catalog-item");
							domList.forEach((value)=>{
								if(value.className.indexOf("catalog-item-active")!==-1){
									value.className=value.className.replace("catalog-item-active","");
								}
							})
							domList[index].className+=" catalog-item-active";
							break findIndex;
						}
						index++;
					}
				}
			}
		},
		beforeRouteUpdate(to,from,next){
			this.addTitleActive(to.params.id);
			next();
		}
	}
</script>

<style scoped>
	.catalog-chapters{
		margin-top:0.12rem;
		padding:0 0.4rem;
	}
	.catalog-chapter-title{
		height:1.173rem;
		line-height:1.173rem;
		font-size:0.4rem;
		color:#333;
		border-bottom:1px solid #e6e6e6;
	}
	.catalog-item{
		height:1.173rem;
		line-height:1.173rem;
		border-bottom:1px solid #e6e6e6;
	}
	.catalog-chapter:last-child .catalog-item:last-child{
		border-bottom: 0;
	}
	.catalog-item-title{
		float:left;
		margin-left:0.533rem;
		width:6.4rem;
		color:#999;
		font-size: 0.373rem;
	}
	.catalog-item-active .catalog-item-title{
		color:#EC6D3A;
	}
	.catalog-item-time{
		float:right;
		padding-left: 0.426rem;
		color:#999;
		text-align: right;
		background:url(../lesson-detail/play.png) center left no-repeat;
		background-size: 0.293rem;
	}
	.catalog-item-active .catalog-item-time{
		background-image: url(../lesson-detail/play-active.png);
		color:#EC6D3A;
	}
</style>



// WEBPACK FOOTER //
// src/components/lesson-chapter/lesson-chapter.vue